export default {
  props: {
    src: {
      type: String
    },
    fit: {
      type: String,
      default: 'cover'
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};